/* Bilan Penombre - quiz engine, orientation, tracking.
   Loaded only on pages that render pm-bilan section. */
(function(){
'use strict';

var VERSION = '1.0';
var root, steps, navPrev, navNext, resultEl, progressBar, stepLabel;
var current = 0;
var answers = {};
var totalSteps = 7;
var submitted = false;

function qs(sel, ctx){ return (ctx||document).querySelector(sel); }
function qsa(sel, ctx){ return Array.prototype.slice.call((ctx||document).querySelectorAll(sel)); }

function track(name, params){
  if(typeof window.lumaPushEvent==='function'){
    var p = Object.assign({assessment_version:VERSION}, params||{});
    window.lumaPushEvent(name, p);
  }
}

function init(){
  root = qs('[data-pm-bilan]');
  if(!root) return;
  steps = qsa('[data-step]', root);
  navPrev = qs('[data-bilan-prev]', root);
  navNext = qs('[data-bilan-next]', root);
  resultEl = qs('[data-bilan-result]', root);
  progressBar = qs('[data-bilan-bar]', root);
  stepLabel = qs('[data-step-num]', root);

  navPrev.addEventListener('click', prev);
  navNext.addEventListener('click', next);

  root.addEventListener('change', onAnswer);
  root.addEventListener('click', function(e){
    if(e.target.closest('[data-bilan-restart]')){
      e.preventDefault();
      restart();
    }
  });

  var formWrap = qs('[data-bilan-form]', root);
  var form = formWrap ? (formWrap.closest('form') || formWrap) : qs('form', root);
  if(form) form.addEventListener('submit', onFormSubmit);

  var declineBtn = qs('[data-bilan-decline]', root);
  if(declineBtn) declineBtn.addEventListener('click', function(e){
    e.preventDefault();
    track('penombre_email_decline',{primary_intent:answers.need||''});
    showResult();
  });

  restoreSession();

  var wasSubmitted = false;
  try{ wasSubmitted = sessionStorage.getItem('pm_bilan_submitted') === '1'; }catch(ex){}
  if(wasSubmitted){
    try{ sessionStorage.removeItem('pm_bilan_submitted'); }catch(ex){}
    submitted = true;
    showResult();
    return;
  }

  showStep(current);
  track('penombre_assessment_view',{source_page_type:pageType(),source_handle:pageHandle()});
}

function pageType(){
  var b = document.body.className;
  if(b.indexOf('template-page')>-1) return 'page';
  if(b.indexOf('template-product')>-1) return 'product';
  if(b.indexOf('template-collection')>-1) return 'collection';
  if(b.indexOf('template-article')>-1) return 'article';
  if(b.indexOf('template-index')>-1) return 'index';
  return 'other';
}
function pageHandle(){
  var m = document.body.className.match(/template-\w+([\w-]+)/);
  return m ? m[1] : '';
}

function showStep(i){
  steps.forEach(function(s,idx){
    s.hidden = idx !== i;
    s.setAttribute('aria-hidden', idx !== i ? 'true' : 'false');
  });
  navPrev.hidden = i === 0;
  navNext.hidden = i >= totalSteps - 1;
  if(resultEl) resultEl.hidden = true;

  var pct = Math.round(((i) / totalSteps) * 100);
  if(progressBar) progressBar.style.width = pct + '%';
  if(stepLabel) stepLabel.textContent = (i + 1);

  root.querySelector('.pm-bilan__nav').hidden = (i >= totalSteps);

  var active = steps[i];
  if(active){
    var first = active.querySelector('input,button,select,textarea');
    if(first) first.focus({preventScroll:true});
    active.scrollIntoView({behavior:'smooth',block:'start'});
  }

  if(i === 0 && !answers._started){
    answers._started = true;
    track('penombre_assessment_start',{source_page_type:pageType()});
  }
}

function onAnswer(e){
  var step = e.target.closest('[data-step]');
  if(!step) return;
  var idx = parseInt(step.getAttribute('data-step'),10) - 1;
  var key = step.getAttribute('data-key');

  if(step.getAttribute('data-multi') === 'true'){
    var checked = qsa('input:checked', step).map(function(c){ return c.value; });
    if(checked.indexOf('none') > -1 && checked.length > 1){
      qsa('input:checked', step).forEach(function(c){
        if(c.value !== 'none') c.checked = false;
      });
      checked = ['none'];
    }
    if(checked.length > 0 && checked.indexOf('none') === -1){
      var noneBox = qs('input[value="none"]', step);
      if(noneBox) noneBox.checked = false;
      checked = checked.filter(function(v){ return v !== 'none'; });
    }
    answers[key] = checked;
  } else {
    answers[key] = e.target.value;
  }
  saveSession();
}

function validate(i){
  var step = steps[i];
  var key = step.getAttribute('data-key');
  var multi = step.getAttribute('data-multi') === 'true';
  if(multi){
    return answers[key] && answers[key].length > 0;
  }
  return !!answers[key];
}

function next(){
  if(!validate(current)){
    var step = steps[current];
    step.classList.add('pm-bilan__step--shake');
    setTimeout(function(){ step.classList.remove('pm-bilan__step--shake'); }, 600);
    var err = qs('.pm-bilan__error', step);
    if(err) err.hidden = false;
    return;
  }
  var err2 = qs('.pm-bilan__error', steps[current]);
  if(err2) err2.hidden = true;

  track('penombre_assessment_step',{step_number:current+1, primary_intent:answers.need||''});

  if(current < totalSteps - 1){
    current++;
    showStep(current);
    saveSession();
  }
  if(current === totalSteps - 1){
    populateEmailStep();
  }
}

function prev(){
  if(current > 0){
    current--;
    showStep(current);
    saveSession();
  }
}

function populateEmailStep(){
  var orient = computeOrientation();
  var preview = qs('[data-result-preview]', root);
  if(preview){
    preview.textContent = orient.level_label;
  }
}

function onFormSubmit(e){
  if(submitted) { e.preventDefault(); return; }
  var emailInput = qs('[data-bilan-email]', root);
  if(!emailInput || !emailInput.value) return;

  var tagsInput = qs('[data-bilan-tags]', root);
  if(tagsInput){
    tagsInput.value = buildTags().join(',');
  }

  submitted = true;
  track('penombre_email_optin',{primary_intent:answers.need||'',marketing_consent:isMarketingChecked()});
  track('penombre_assessment_complete',{primary_intent:answers.need||'',orientation:computeOrientation().key});

  try{ sessionStorage.setItem('pm_bilan_submitted', '1'); }catch(ex){}
}

function isMarketingChecked(){
  var cb = qs('input[name="contact[accepts_marketing]"]', root);
  return cb ? cb.checked : false;
}

function buildTags(){
  var tags = ['penombre_lead','source_bilan'];
  var need = answers.need || 'unknown';
  if(need === 'move') tags.push('intent_move');
  else if(need === 'rest') tags.push('intent_rest');
  else if(need === 'travel') tags.push('intent_travel');
  else if(need === 'puppy') tags.push('intent_puppy');
  else if(need.indexOf('behavior') === 0) tags.push('intent_behavior');

  if(need === 'behavior_reactivity') tags.push('topic_reactivity');
  else if(need === 'behavior_solitude') tags.push('topic_solitude');
  else if(need === 'behavior_fear') tags.push('topic_fear');

  var o = computeOrientation();
  tags.push('orientation_' + o.key);
  tags.push('sequence_plan_7d');
  return tags;
}

function computeOrientation(){
  var need = answers.need || 'unknown';
  var onset = answers.onset || 'unknown';
  var signs = answers.signs || [];
  var hasWarning = signs.length > 0 && signs.indexOf('none') === -1;

  var isVetPriority = false;
  var vetSigns = ['pain','appetite_change','disorientation','unusual_aggression','severe_distress'];
  for(var i=0;i<vetSigns.length;i++){
    if(signs.indexOf(vetSigns[i]) > -1){ isVetPriority = true; break; }
  }
  if(onset === 'sudden' && hasWarning) isVetPriority = true;
  if(signs.indexOf('mobility_difficulty') > -1 && onset === 'sudden') isVetPriority = true;

  var isVetRecommended = false;
  if(!isVetPriority && hasWarning) isVetRecommended = true;

  if(isVetPriority) return orientations.vet_priority;
  if(isVetRecommended) return orientations.vet_recommended;

  if(need === 'move') return orientations.move;
  if(need === 'rest') return orientations.rest;
  if(need === 'travel') return orientations.travel;
  if(need.indexOf('behavior') === 0 || need === 'puppy') return orientations.behavior;
  return orientations.unknown;
}

var orientations = {
  vet_priority: {
    key: 'vet',
    level: 4,
    level_label: 'Avis veterinaire prioritaire',
    level_class: 'pm-bilan__level--vet',
    title: 'Un avis veterinaire constitue la prochaine etape la plus prudente',
    intro: 'Un changement soudain ou associe a une douleur, une gene physique, une desorientation ou une agressivite inhabituelle peut avoir une cause medicale. Un bilan en ligne ne permet pas de l\'ecarter. Contactez un veterinaire avant d\'envisager un produit ou un travail comportemental.',
    observe: [
      'Notez la date exacte d\'apparition du changement',
      'Filmez une courte video du comportement si possible',
      'Relevez tout changement d\'appetit ou de sommeil'
    ],
    avoid: 'Ne tentez pas de corriger un comportement qui pourrait etre lie a une douleur.',
    action: 'Appelez votre veterinaire pour decrire les signes observes et convenir d\'un rendez-vous.',
    cta_label: 'Preparer les observations a transmettre',
    cta_url: '/blogs/guides/signes-douleur-articulaire-chien-grille-observation',
    cta2_label: 'Lire les signes a surveiller',
    cta2_url: '/blogs/guides/signes-douleur-articulaire-chien-grille-observation',
    guide_label: '',
    guide_url: '',
    product_url: '',
    disclaimer: 'Ce resultat ne constitue pas un diagnostic. Seul un veterinaire peut evaluer l\'etat de sante de votre chien.'
  },
  vet_recommended: {
    key: 'vet',
    level: 3,
    level_label: 'Avis veterinaire recommande',
    level_class: 'pm-bilan__level--vet-soft',
    title: 'Un controle veterinaire serait une precaution raisonnable',
    intro: 'Certains des signes que vous avez observes peuvent avoir une composante medicale. Avant d\'envisager un amenagement ou un travail comportemental, il serait prudent de verifier aupres d\'un veterinaire que rien de physique ne l\'explique.',
    observe: [
      'Notez les moments ou le signe apparait (matin, apres effort, au repos)',
      'Evaluez si le signe s\'aggrave ou reste stable',
      'Observez s\'il y a des positions ou mouvements qu\'il evite'
    ],
    avoid: 'N\'interpretez pas un signe physique comme un probleme de comportement.',
    action: 'Prenez rendez-vous chez votre veterinaire dans les prochains jours pour un bilan.',
    cta_label: 'Preparer les observations a transmettre',
    cta_url: '/blogs/guides/signes-douleur-articulaire-chien-grille-observation',
    cta2_label: '',
    cta2_url: '',
    guide_label: '',
    guide_url: '',
    product_url: '',
    disclaimer: 'Ce resultat ne constitue pas un diagnostic. Seul un veterinaire peut evaluer l\'etat de sante de votre chien.'
  },
  behavior: {
    key: 'behaviorist',
    level: 2,
    level_label: 'Aide comportementale pertinente',
    level_class: 'pm-bilan__level--behavior',
    title: 'Observer, comprendre, puis ajuster',
    intro: 'La situation que vous decrivez releve probablement du comportement. Avant d\'agir, il est utile d\'observer pour comprendre ce qui declenche la reaction de votre chien.',
    observe: [
      'Identifiez le contexte precis : lieu, moment, presence d\'autres chiens ou personnes',
      'Notez l\'intensite de la reaction (echelle de 1 a 5)',
      'Reperer les signaux qui precedent la reaction (oreilles, queue, posture)'
    ],
    avoid: 'Ne grondez pas votre chien pendant une reaction : cela risque d\'aggraver son stress sans resoudre la cause.',
    action: 'Aujourd\'hui, lors d\'une situation declenchante, contentez-vous d\'observer et de noter, sans intervenir pour corriger.',
    cta_label: 'Decouvrir la consultation comportementale',
    cta_url: '/pages/consultation-comportementale',
    cta2_label: 'Lire le guide reactivite',
    cta2_url: '/blogs/guides/mon-chien-est-reactif-reconstruire-des-promenades-agreables',
    guide_label: 'Comprendre la reactivite',
    guide_url: '/blogs/guides/mon-chien-est-reactif-reconstruire-des-promenades-agreables',
    product_url: '',
    disclaimer: 'Ce bilan ne remplace pas une evaluation comportementale personnalisee. Laurie, comportementaliste canine certifiee, peut vous accompagner si la situation persiste.'
  },
  move: {
    key: 'observe',
    level: 1,
    level_label: 'Observer et amenager',
    level_class: 'pm-bilan__level--observe',
    title: 'Adapter son environnement pour l\'aider a bouger',
    intro: 'L\'hesitation que vous observez est souvent liee a la hauteur, a la stabilite ou a la confiance de votre chien dans un mouvement. Quelques amenagements simples peuvent faire une vraie difference.',
    observe: [
      'Mesurez la hauteur a franchir (voiture, canape, lit)',
      'Observez s\'il hesite plus le matin ou en fin de journee',
      'Verifiez si le sol est glissant a l\'endroit ou il hesite',
      'Notez s\'il y a une raideur visible apres un moment de repos'
    ],
    avoid: 'Ne le soulevez pas brutalement : un mouvement non anticipe peut generer une apprehension durable.',
    action: 'Placez un tapis antiderapant devant l\'obstacle ou il hesite le plus souvent.',
    cta_label: 'Voir les solutions de mobilite',
    cta_url: '/collections/move',
    cta2_label: '',
    cta2_url: '',
    guide_label: 'Grille d\'observation mobilite',
    guide_url: '/blogs/guides/signes-douleur-articulaire-chien-grille-observation',
    product_url: '/collections/move',
    disclaimer: 'Si l\'hesitation est soudaine ou accompagnee de douleur, consultez votre veterinaire avant d\'amenager.'
  },
  rest: {
    key: 'observe',
    level: 1,
    level_label: 'Observer et amenager',
    level_class: 'pm-bilan__level--observe',
    title: 'Comprendre ce qui perturbe son repos',
    intro: 'Un chien qui dort mal compense souvent en silence. Observer ses positions, son environnement et ses changements de rythme peut reveler ce dont il a besoin.',
    observe: [
      'Observez les changements de position pendant la nuit',
      'Verifiez la temperature et la ventilation de son espace de repos',
      'Notez s\'il cherche des surfaces fraiches ou dures',
      'Evaluez si son couchage actuel est encore adapte a son poids et a son age'
    ],
    avoid: 'Ne confondez pas un trouble du sommeil avec un besoin de confort : un changement soudain de sommeil justifie un avis veterinaire.',
    action: 'Ce soir, observez combien de fois il change de position en une heure et notez-le.',
    cta_label: 'Voir les couchages',
    cta_url: '/collections/rest',
    cta2_label: 'Comprendre le besoin de repos',
    cta2_url: '/blogs/guides/comprendre-le-besoin-de-repos-de-son-chien',
    guide_label: 'Le besoin de repos du chien',
    guide_url: '/blogs/guides/comprendre-le-besoin-de-repos-de-son-chien',
    product_url: '/collections/rest',
    disclaimer: 'Ce bilan ne constitue pas un diagnostic. En cas de doute sur l\'etat de sante de votre chien, consultez votre veterinaire.'
  },
  travel: {
    key: 'observe',
    level: 1,
    level_label: 'Observer et amenager',
    level_class: 'pm-bilan__level--observe',
    title: 'Differencier peur, instabilite et inconfort',
    intro: 'Les difficultes de trajet peuvent avoir des causes differentes : peur de la voiture, instabilite physique sur la banquette, inconfort lie a la chaleur ou a la duree. Observer permet de cibler la bonne reponse.',
    observe: [
      'Notez s\'il hesite avant de monter ou une fois installe',
      'Observez s\'il salive, halete ou tremble pendant le trajet',
      'Distinguez l\'agitation (peur) de la recherche de position (inconfort physique)',
      'Testez un trajet court pour isoler le moment ou le stress apparait'
    ],
    avoid: 'Ne forcez pas votre chien a monter en voiture : une mauvaise experience renforce l\'apprehension.',
    action: 'Demain, ouvrez le coffre sans partir nulle part. Laissez-le explorer librement pendant deux minutes.',
    cta_label: 'Voir les solutions de voyage',
    cta_url: '/collections/travel',
    cta2_label: 'Chien qui refuse la voiture',
    cta2_url: '/blogs/guides/chien-refuse-monter-voiture-que-faire',
    guide_label: 'Mon chien refuse la voiture',
    guide_url: '/blogs/guides/chien-refuse-monter-voiture-que-faire',
    product_url: '/collections/travel',
    disclaimer: 'Si votre chien vomit regulierement en voiture, consultez votre veterinaire : le mal des transports a des solutions medicales.'
  },
  unknown: {
    key: 'observe',
    level: 1,
    level_label: 'Observer et amenager',
    level_class: 'pm-bilan__level--observe',
    title: 'Commencer par observer',
    intro: 'Vous n\'etes pas encore certain de ce qui se passe, et c\'est normal. Observer methodiquement pendant quelques jours aide a identifier le bon type d\'aide.',
    observe: [
      'Notez les moments ou le changement est le plus visible',
      'Comparez son comportement du matin et du soir',
      'Observez s\'il mange, boit et elimine normalement'
    ],
    avoid: 'Ne cherchez pas une solution avant d\'avoir identifie le probleme : une reponse inadaptee peut masquer un signe important.',
    action: 'Prenez cinq minutes ce soir pour noter trois choses que vous avez observees aujourd\'hui.',
    cta_label: 'Decouvrir nos guides',
    cta_url: '/pages/better-life-project',
    cta2_label: 'Nous ecrire pour en parler',
    cta2_url: '/pages/contact',
    guide_label: '',
    guide_url: '',
    product_url: '',
    disclaimer: 'En cas de doute, votre veterinaire reste le premier interlocuteur.'
  }
};

function getDesiredLabel(){
  var map = {
    'serene_walks': 'Des promenades plus sereines',
    'alone_ok': 'Pouvoir le laisser seul sans detresse',
    'peaceful_sleep': 'Le voir dormir paisiblement',
    'travel_again': 'L\'emmener a nouveau avec vous',
    'climb_easy': 'Le voir monter sans hesiter',
    'understand': 'Comprendre ses reactions',
    'simpler_life': 'Retrouver un quotidien plus simple'
  };
  return map[answers.desired] || '';
}

function getAgeLabel(){
  var map = {puppy:'Chiot',adolescent:'Adolescent',adult:'Adulte',senior:'Senior',unknown:''};
  return map[answers.age] || '';
}

function showResult(){
  var orient = computeOrientation();

  track('penombre_assessment_result',{
    primary_intent: answers.need||'',
    orientation: orient.key,
    source_page_type: pageType()
  });

  steps.forEach(function(s){ s.hidden = true; });
  root.querySelector('.pm-bilan__nav').hidden = true;
  root.querySelector('.pm-bilan__progress').hidden = true;

  var html = '';
  html += '<div class="pm-bilan__result-level ' + orient.level_class + '">';
  html += '<span class="pm-bilan__level-badge">' + orient.level_label + '</span>';
  html += '</div>';

  html += '<h2 class="pm-bilan__result-title">' + orient.title + '</h2>';

  var desired = getDesiredLabel();
  if(desired){
    html += '<p class="pm-bilan__result-desired">Votre souhait : ' + desired + '</p>';
  }

  html += '<p class="pm-bilan__result-intro">' + orient.intro + '</p>';

  html += '<div class="pm-bilan__result-section">';
  html += '<h3>Ce qu\'il est utile d\'observer</h3><ul>';
  orient.observe.forEach(function(o){ html += '<li>' + o + '</li>'; });
  html += '</ul></div>';

  html += '<div class="pm-bilan__result-section">';
  html += '<h3>Une action sans risque aujourd\'hui</h3>';
  html += '<p>' + orient.action + '</p>';
  html += '</div>';

  html += '<div class="pm-bilan__result-section pm-bilan__result-avoid">';
  html += '<h3>L\'erreur a eviter</h3>';
  html += '<p>' + orient.avoid + '</p>';
  html += '</div>';

  if(orient.guide_url){
    html += '<div class="pm-bilan__result-section">';
    html += '<h3>Guide recommande</h3>';
    html += '<a href="' + orient.guide_url + '" class="pm-bilan__guide-link" data-bilan-guide>' + orient.guide_label + ' &rarr;</a>';
    html += '</div>';
  }

  html += '<div class="pm-bilan__result-section pm-bilan__result-warning">';
  html += '<h3>Quand consulter un veterinaire</h3>';
  html += '<p>En cas de douleur apparente, boiterie soudaine, changement brutal d\'appetit, desorientation ou agressivite inhabituelle, contactez votre veterinaire sans attendre.</p>';
  html += '</div>';

  html += '<div class="pm-bilan__result-ctas">';
  html += '<a href="' + orient.cta_url + '" class="btn btn--primary" data-bilan-cta>' + orient.cta_label + '</a>';
  if(orient.cta2_url){
    html += '<a href="' + orient.cta2_url + '" class="btn btn--outline" data-bilan-cta2>' + orient.cta2_label + '</a>';
  }
  html += '</div>';

  if(submitted){
    html += '<p class="pm-bilan__result-plan">Vous recevrez votre Plan Penombre sur 7 jours par email : observations guidees, erreurs a eviter et prochaines etapes adaptees a votre chien.</p>';
  }

  html += '<p class="pm-bilan__disclaimer">' + orient.disclaimer + '</p>';

  html += '<div class="pm-bilan__restart">';
  html += '<a href="#" data-bilan-restart>Recommencer le bilan</a>';
  html += '</div>';

  resultEl.innerHTML = html;
  resultEl.hidden = false;
  resultEl.scrollIntoView({behavior:'smooth',block:'start'});

  if(!resultEl._bilanClick){
    resultEl._bilanClick = true;
    resultEl.addEventListener('click', function(e){
      var o = computeOrientation();
      var link = e.target.closest('[data-bilan-cta]');
      if(link) track('penombre_result_cta_click',{orientation:o.key,url:link.getAttribute('href')});
      var cta2 = e.target.closest('[data-bilan-cta2]');
      if(cta2) track('penombre_result_cta2_click',{orientation:o.key,url:cta2.getAttribute('href')});
      var guide = e.target.closest('[data-bilan-guide]');
      if(guide) track('penombre_result_guide_click',{orientation:o.key,url:guide.getAttribute('href')});
    });
  }

  clearSession();
}

function restart(){
  answers = {};
  current = 0;
  submitted = false;
  resultEl.hidden = true;
  resultEl.innerHTML = '';
  root.querySelector('.pm-bilan__progress').hidden = false;
  qsa('input', root).forEach(function(inp){ inp.checked = false; });
  var emailInp = qs('[data-bilan-email]', root);
  if(emailInp) emailInp.value = '';
  showStep(0);
  clearSession();
}

function saveSession(){
  try{ sessionStorage.setItem('pm_bilan', JSON.stringify({step:current,answers:answers})); }catch(e){}
}
function restoreSession(){
  try{
    var d = JSON.parse(sessionStorage.getItem('pm_bilan'));
    if(d && d.answers){
      answers = d.answers;
      current = d.step || 0;
      Object.keys(answers).forEach(function(key){
        var step = qs('[data-key="'+key+'"]', root);
        if(!step) return;
        var val = answers[key];
        if(Array.isArray(val)){
          val.forEach(function(v){
            var inp = qs('input[value="'+v+'"]', step);
            if(inp) inp.checked = true;
          });
        } else if(val){
          var inp = qs('input[value="'+val+'"]', step);
          if(inp) inp.checked = true;
        }
      });
    }
  }catch(e){}
}
function clearSession(){
  try{ sessionStorage.removeItem('pm_bilan'); }catch(e){}
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

window.PenombreBilan = { restart: restart };
})();
